import { createRouter, createWebHistory } from 'vue-router'

import { routes, whiteList } from './routeConfig';
import vuex from '@/store/index';

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_CONTEXT_PATH),
  scrollBehavior: () => ({ y: 0 }),
  routes,
});
router.beforeEach(async (to, from, next) => {
  if (to.path === '/') return next({ path: '/home', replace: true, query: to.query });
  await vuex.dispatch('lang/checkLang');
  if (!vuex.state.app.hasMenuLoaded) { // 没加载过menu
    try {
      await vuex.dispatch('app/queryMenu');
      next({ path: to.path, replace: true, query: to.query });
    } catch (err) {
      next({ path: '/home', replace: true, query: to.query });
    }
  } else {
    next();
  }
});

export default router
